"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.angleRight = void 0;
var angleRight = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M595 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"
    }
  }]
};
exports.angleRight = angleRight;